import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const Period = styled.div`
  padding-top: ${pxToRem('28px')};
  height: 80%;
  & > div {
    :is(:first-child) {
      margin-bottom: ${pxToRem('10px')};
    }
  }
`;
export const ReportData = styled.div`
  padding: ${pxToRem('80px')} 0;
`;

export const PeriodDrodDown = styled.div`
  margin-top: ${pxToRem('24px')};
  max-width: ${pxToRem('350px')};
  margin: auto;
  height: ${pxToRem('72px')};
  margin-top: ${pxToRem('24px')};
  border: solid ${pxToRem('2px')} #f0f0f0;
  border-radius: ${pxToRem('36px')};
  padding: ${pxToRem('8px')};

  & .Select__control {
    align-content: center;

    &--menu-is-open {
      background-color: ${props => props.theme.colors.blue.five};
      border-radius: ${pxToRem('36px')};
      padding: ${pxToRem('16px')};
    }
  }
`;

export const RowDropDown = styled.div`
  display: flex;
  justify-content: center;
`;

export const CenterText = styled.div`
  text-align: center;
  padding: 0 calc(${pxToRem('138px')} - 2.28rem);
  margin-top: calc(2rem - ${pxToRem('40px')});
  margin-bottom: ${pxToRem('24px')};
`;
